export default buffer => btoa(new Uint8Array(buffer).reduce(
  (dataString, byte) => `${dataString}${String.fromCharCode(byte)}`,
  ''))
